import React, { useState } from 'react';
import ObservationsGlance from '../components/observations/ObservationsGlance';
import HealthScoreCard from '../components/home/HealthScoreCard';
import TodayCard from '../components/home/TodayCard';
import CompletenessCard from '../components/home/CompletenessCard';
import StackConfirmCard from '../components/supplements/StackConfirmCard';

// Home — the glance layer, child-simple. What's moving (top three, one tap
// each), the score in one row, today's four numbers, and two quick questions.
// Logging is the Log page; the full feed is Insights; the goals are You.

const HomePage = () => {
  // Answering an observation changes what the rest of the page should show
  // (the score's inputs are the same numbers), so a resolution refreshes it.
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="relative">
      <div className="lite-top -top-10" aria-hidden="true" />
      <div className="lite-spot left-1/2 top-[520px] -translate-x-1/2" aria-hidden="true" />
    <div className="lite-above mx-auto max-w-[1080px] px-4 sm:px-6 lg:px-10">
      <ObservationsGlance onResolved={() => setRefreshKey((k) => k + 1)} />

      <section className="mt-10">
        <HealthScoreCard refreshKey={refreshKey} />
      </section>

      <TodayCard />

      <section className="mt-10">
        <h2 className="mb-3.5 text-[1.2rem] font-medium tracking-[-0.015em]">Two quick questions</h2>
        <div className="rounded-xl border border-line divide-y divide-line">
          <StackConfirmCard />
          <CompletenessCard />
        </div>
      </section>
    </div>
    </div>
  );
};

export default HomePage;
